import { RegiaoModel } from "./regiao.model";

export class ArmazemModel {
    id: number;
    descricao: String;
    regiao: RegiaoModel;
}


// WEBPACK FOOTER //
// /app/src/app/model/endereco/armazem.model.ts